import React, { Component } from "react";
import { Link } from "react-router-dom";
import { ListGroup, Panel } from "react-bootstrap";

import {
  JobWorkersList,
  LinkIfWorkerActive,
  PanelHeader,
  ViewPaymentHistoryLinkItem,
  workerNotActiveTooltip,
} from "./utils";
import { PaymentDetails } from "types";

const WorkerActionsList = ({ job, jobWorker: { active }, paymentDetails }) => {
  const JobWorkerLink = props => (
    <LinkIfWorkerActive
      tooltip={workerNotActiveTooltip}
      active={active}
      {...props}
    />
  );

  return (
    <ul className="list-inline" style={{ marginBottom: 0 }}>
      {paymentDetails.isFixed &&
        paymentDetails !==
          PaymentDetails.PAYMENT_TYPES.FIXED_MONTH_AUTOMATIC && (
          <li>
            <JobWorkerLink to={`/contractor/jobs/${job}/mark_event/`}>
              <span>
                <i className="far fa-list-alt" />&nbsp;Record Billable Event
              </span>
            </JobWorkerLink>
          </li>
        )}
      {!paymentDetails.isFixed && (
        <li>
          <JobWorkerLink to={`/contractor/jobs/${job}/time_tracker/`}>
            <span>
              <i className="far fa-clock" />&nbsp;Time Tracker
            </span>
          </JobWorkerLink>
        </li>
      )}
      {paymentDetails.allow_expenses && (
        <li>
          <JobWorkerLink to={`/contractor/jobs/${job}/expenses/`}>
            <span>
              <i className="fas fa-dollar-sign" />&nbsp;Track Expenses
            </span>
          </JobWorkerLink>
        </li>
      )}
      <li>
        <Link to={`/contractor/jobs/${job}/`}>
          <i className="far fa-newspaper" />&nbsp;Job Details
        </Link>
      </li>
    </ul>
  );
};

class ActiveJobsPanel extends Component {
  render() {
    const { jobWorkers, eventKey } = this.props;
    return (
      <Panel eventKey={eventKey}>
        <PanelHeader
          title="Active Jobs"
          bsStyle="primary"
          count={jobWorkers.length}
        />
        <Panel.Collapse>
          <ListGroup>
            {jobWorkers.length > 0 && <ViewPaymentHistoryLinkItem />}
            <JobWorkersList
              panelType="active"
              ComponentClass={WorkerActionsList}
              {...this.props}
            />
          </ListGroup>
        </Panel.Collapse>
      </Panel>
    );
  }
}

export default ActiveJobsPanel;
